import {Component, ElementRef, Renderer2, ChangeDetectorRef, ViewEncapsulation} from '@angular/core';
import { PONodeComponent } from '../abstract-classes/po-node/ponode.component';
import { ArrangementNodeComponent } from '../arrangement-node/arrangement-node.component';
import { SubCategoryNodeComponent } from '../sub-catergory-node/sub-category-node.component';
import { ProductNodeComponent } from '../product-node/product-node.component';
import { DetailScreensService } from '../detail-screens-module/services/detail-screens-service';
import { ProductOverviewService } from '../../../services/product-overview/product-overview.service';
import { DomService } from '../../../services/dom-service/dom.service';
import {PopupService} from '../popup-component/popup.service/popup.service';
import {UiHelperService} from '../../../services/shared/helpers/ui-helper.service';

@Component({
  selector: 'app-category-node',
  templateUrl: '../abstract-classes/po-node/ponode.component.html',
  styleUrls: ['../abstract-classes/po-node/ponode.component.css'],
})
export class CategoryNodeComponent extends PONodeComponent {

  nodeType = 'category-node';
  expanded = true;

  constructor(domService: DomService, productOverviewService: ProductOverviewService,
              el: ElementRef, renderer: Renderer2, changeRef: ChangeDetectorRef,
              detailsScreenService: DetailScreensService, popupService: PopupService, uiHelper: UiHelperService) {
    super(domService, detailsScreenService, changeRef, el, renderer, productOverviewService, popupService, uiHelper);
  }

  initializeComponents() {
    // @ts-ignore
    this.hierarchyChildren.forEach((child) => {
      // @ts-ignore
      this.determineChildComponentType(child, SubCategoryNodeComponent);
      if (this.expanded) { child.expandByProdCluster = true; }
      if (this.childComponentType !== ArrangementNodeComponent) {
        this.children.push(this.createComponent(child, this.childComponentType));
      }
    });
    if (this.listOfArrangementsToCreate.length !== 0) {
      this.createArrangements().forEach((arrangement) => {
        this.children.push(arrangement);
      });
    }
    const numberOfChildren = this.children.length;
    this.children[numberOfChildren - 1].isLastChild = true;
    this.children.forEach((child) => {
      if (child.nodeType !== 'expired-node' && child.nodeType !== 'more-node' && child.expandable && child.hierarchyChildren.length !== 0) {
        child.initializeComponents();
      } else {
        child.expanded = false;
      }
      this.changeRef.detectChanges();
    });

  }

  determineChildComponentType(child, defaultComponentType) {
    if (this.childIsArrangement(child)) {
      this.childComponentType = ArrangementNodeComponent;
      this.listOfArrangementsToCreate.push(child);
    } else if (this.childHasArrangements(child)) {
      this.childComponentType = ProductNodeComponent;
    } else {
      this.childComponentType = defaultComponentType;
    }
  }
}
